import React from "react";
import { Input, Form, Select, Switch } from "antd";

const { Option } = Select;

const FormFields = ({ roles, isRolesLoading, isEditing = false }) => {
  return (
    <>
      <Form.Item name="firstName" label="Prénom" rules={[{ required: true, message: "Veuillez entrer le prénom" }]}>
        <Input placeholder="Prénom" />
      </Form.Item>
      <Form.Item name="lastName" label="Nom de famille" rules={[{ required: true, message: "Veuillez entrer le nom de famille" }]}>
        <Input placeholder="Nom de famille" />
      </Form.Item>
      <Form.Item name="email" label="Email" rules={[{ required: true, type: "email", message: "Veuillez entrer un email valide" }]}>
        <Input placeholder="Email" />
      </Form.Item>
      <Form.Item
        name="password"
        label={isEditing ? "Nouveau Mot de passe (optionnel)" : "Mot de passe"}
        rules={[{ required: !isEditing, message: "Veuillez entrer le mot de passe" }]}
      >
        <Input.Password placeholder={isEditing ? "Laisser vide pour ne pas changer" : "Mot de passe"} />
      </Form.Item>
      <Form.Item name="phone" label="Téléphone">
        <Input placeholder="Téléphone" />
      </Form.Item>
      <Form.Item name="role" label="Rôle" rules={[{ required: true, message: "Veuillez choisir un rôle" }]}>
        <Select placeholder="Choisir un rôle" loading={isRolesLoading} allowClear>
          {roles.map((role) => (
            <Option key={role.id} value={role.id}>
              {role.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name="status" label="Statut" valuePropName="checked" initialValue={true}>
        <Switch checkedChildren="Actif" unCheckedChildren="Inactif" />
      </Form.Item>
    </>
  );
};

export default FormFields;